import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'bold',
  standalone: true
})
export class BoldPipe implements PipeTransform {

  transform(value: any, searchTerm: any): any {
    if (!searchTerm) {return value;}
    const regExp = new RegExp(searchTerm, 'gi');
    const replaced = value?.replace(regExp, '<span class="department-bold">$&</span>');
    return replaced;
  }

}
